/* ==================================================================
   ARRIVAL DATES, wherever a promise is printed (2026-09-20)

   This was inside nx-product.js, which only the product page loads — and
   the cart drawer, which is on every page, needed the same dates: an
   estimate that disagrees with the product page is worse than none, and
   Merchant Center reads both. One file, one arithmetic, two callers.

   The caller prints the shipping policy's windows in business days (data-dispatch, data-transit, from shop.metafields.nextology.delivery_days) and a
   sentence without dates; this replaces the sentence with the dates of an order placed today.
   Business days skip weekends and US federal holidays, as the policy counts them; USPS does not
   deliver on those. (The windows are 1-3 and 6-8 since 2026-09-19; 10-15 below was the window of the day.)
   Checked before it shipped: an order on 2026-09-14 with 1-3 and 10-15 arrives
   Sep 29 - Oct 8, and one on 2026-11-20 steps over Thanksgiving to Dec 8 - Dec 17. */
(function () {
  var boxes = document.querySelectorAll('[data-nx-delivery]');

  // n-th weekday of a month (weekday 0 = Sunday); n = -1 is the last one.
  function nthWeekday(year, month, weekday, n) {
    if (n > 0) {
      var first = new Date(year, month, 1);
      first.setDate(1 + ((7 + weekday - first.getDay()) % 7) + (n - 1) * 7);
      return first;
    }
    var last = new Date(year, month + 1, 0);
    last.setDate(last.getDate() - ((7 + last.getDay() - weekday) % 7));
    return last;
  }
  // A fixed-date holiday that falls on a weekend is observed on the nearest weekday.
  function observed(year, month, day) {
    var d = new Date(year, month, day);
    if (d.getDay() === 6) d.setDate(d.getDate() - 1);
    if (d.getDay() === 0) d.setDate(d.getDate() + 1);
    return d;
  }
  function dayKey(d) {
    return d.getFullYear() + '-' + d.getMonth() + '-' + d.getDate();
  }

  var today = new Date();
  today.setHours(12, 0, 0, 0);
  var holidays = {};
  [today.getFullYear(), today.getFullYear() + 1].forEach(function (y) {
    [
      observed(y, 0, 1), nthWeekday(y, 0, 1, 3), nthWeekday(y, 1, 1, 3), nthWeekday(y, 4, 1, -1),
      observed(y, 5, 19), observed(y, 6, 4), nthWeekday(y, 8, 1, 1), nthWeekday(y, 9, 1, 2),
      observed(y, 10, 11), nthWeekday(y, 10, 4, 4), observed(y, 11, 25)
    ].forEach(function (d) {
      holidays[dayKey(d)] = true;
    });
  });

  function addBusinessDays(from, n) {
    var d = new Date(from.getTime());
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6 && !holidays[dayKey(d)]) n -= 1;
    }
    return d;
  }

  /* A table, not `Intl.DateTimeFormat`. The first Intl object on a page loads the browser's locale
     data, and on a phone-grade CPU that is 102 ms of the 177 ms this file spent starting up
     (measured 2026-09-16 at CPU 4x): more than every other thing here together, for a string a
     twelve-item array prints exactly — "Sep 29". The shop sells in one market in one language, so
     there is nothing for a locale to decide. */
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  /* The UK, Australia and New Zealand read the day first — "3 Nov", not "Nov 3" (2026-11-02, UK market).
     Shopify prints the visitor's market country in Shopify.country. */
  var DAY_FIRST = { GB: 1, AU: 1, NZ: 1, IE: 1 }[(window.Shopify && window.Shopify.country) || ''] === 1;
  function format(d) {
    return DAY_FIRST ? d.getDate() + ' ' + MONTHS[d.getMonth()] : MONTHS[d.getMonth()] + ' ' + d.getDate();
  }

  function fill(box) {
    var dispatch = (box.getAttribute('data-dispatch') || '').split(',').map(Number);
    var transit = (box.getAttribute('data-transit') || '').split(',').map(Number);
    var out = box.querySelector('[data-nx-delivery-text]');
    var numbers = dispatch.concat(transit);
    if (!out || dispatch.length !== 2 || transit.length !== 2) return;
    if (numbers.some(function (n) { return !(n >= 0); })) return;

    var earliest = addBusinessDays(addBusinessDays(today, dispatch[0]), transit[0]);
    var latest = addBusinessDays(addBusinessDays(today, dispatch[1]), transit[1]);
    var dates = document.createElement('span');
    // the hero styles the span by its own class; the cart by the neutral one
    dates.className = 'nx-product-hero__promise-date nx-delivery-date';
    dates.textContent = format(earliest) + ' – ' + format(latest);
    // The phone's promise reads as a sentence; the trust line from 750px up says "Arrives" and
    // leaves free shipping to the item next to it.
    out.textContent = box.getAttribute('data-prefix') || 'Free and tracked, arrives ';
    out.appendChild(dates);
    box.setAttribute('data-nx-delivery-done', '');
  }

  function fillAll() {
    document.querySelectorAll('[data-nx-delivery]:not([data-nx-delivery-done])').forEach(fill);
  }
  fillAll();

  /* THE LAST DAY TO ORDER for a date (2026-10-14, sections/nx-gift-deadline.liquid): the latest order day whose
     LATEST arrival, by the same windows and the same business days as above, still falls on or before
     data-holiday. The block is printed hidden and shown only from data-from to that day (?nx_preview=gift: any
     day), so a deadline that has passed is never on the page. Checked: windows 1-3 + 6-8, holiday 2026-12-24
     gives Wed Dec 9 (Dec 9 + 3 = Dec 14, + 8 = Dec 24). */
  function ymd(s) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s || '');
    if (!m) return null;
    var d = new Date(+m[1], +m[2] - 1, +m[3]);
    d.setHours(12, 0, 0, 0);
    return d;
  }
  document.querySelectorAll('[data-nx-cutoff]').forEach(function (box) {
    var dispatch = (box.getAttribute('data-dispatch') || '').split(',').map(Number);
    var transit = (box.getAttribute('data-transit') || '').split(',').map(Number);
    var holiday = ymd(box.getAttribute('data-holiday'));
    var from = ymd(box.getAttribute('data-from'));
    if (!holiday || dispatch.length !== 2 || transit.length !== 2) return;
    var last = new Date(holiday.getTime());
    for (var i = 0; i < 90 && addBusinessDays(addBusinessDays(last, dispatch[1]), transit[1]) > holiday; i++) {
      last.setDate(last.getDate() - 1);
    }
    var preview = /[?&]nx_preview=gift(&|$)/.test(location.search);
    if (!preview && ((from && today < from) || today > last)) return;
    // order by, ships by (the policy's longest dispatch from that day), arrives by (the holiday itself)
    var put = function (sel, d) { box.querySelectorAll(sel).forEach(function (el) { el.textContent = format(d); }); };
    put('[data-nx-cutoff-date]', last);
    put('[data-nx-cutoff-ship]', addBusinessDays(last, dispatch[1]));
    put('[data-nx-cutoff-arrive]', holiday);
    box.hidden = false;
  });

  /* ⚠ The cart drawer is REPLACED after every add: Shopify re-renders that section and the new
     markup has never met this script, so the line kept its date-less fallback while the product
     page had dates (2026-09-20). Watch for nodes arriving and fill them; the check is a selector
     on already-changed DOM, so it costs nothing while nothing changes. */
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; fillAll(); }, 60);
  }).observe(document.body, { childList: true, subtree: true });
})();
